<template>
  <div
    id="parentx"
    v-if="
      this.$route.path !== '/login' &&
      this.$route.path !== '/register' &&
      this.$route.path !== '/Resetpassword' &&
      this.$route.path !== '/login2'
    "
  >
    <BetagroSidebar
      v-if="username === 'betagrodemo' || admin == 'betagrodemo'"
    />

    <QCONSidebar v-else-if="username === 'QCONdemo'" />
    <AjinomotoSidebar v-else-if="username === 'ajinomotodemo' || admin == 'ajinomotodemo'" />
    <CamillianSicebar v-else-if="username === 'camilliandemo'" />
    <CPFSidebar v-else-if="username === 'CPFadmin'" />
    <EncoSidebar v-else-if="username.match('enco')" />
    <FrasersSidebar
      v-else-if="
        username.match('frasers') ||
        [
          'Kendell',
          'Endeavor',
          'Unicorn',
          'JasperW1',
          'JasperW3',
          'Ywood31',
          'Ywood32',
          'Ywood33',
          'Ywood34',
          'Garnet',
          'Galaxy',
        ].includes(username)
      "
    />
    <GPSSidebar v-else-if="username === 'GPSdemo'" />
    <IapcSidebar v-else-if="admin === 'i-APCdemo'" />
    <KPcoolSidebar v-else-if="username === 'KPcooldemo'" />
    <KubotaSidebar v-else-if="username === 'kubotademo'" />
    <LindeSidebar v-else-if="username === 'lindedemo'" />
    <LTCSidebar v-else-if="username === 'LTCdemo'" />
    <MhesiSidebar v-else-if="username === 'MHESIdemo'"/>
    <OfficemateSidebar v-else-if="username === 'Officematedemo'" />
    <PttSidebar v-else-if="username === 'pttdemo'" />
    <RamaSidebar v-else-if="username === 'Ramademo'" />
    <RFIDSidebar v-else-if="username === 'RFIDdemo'" />
    <RivacoldSidebar
      v-else-if="username === 'Rivacold01' || admin === 'Rivacold01'"
    />

    <SbrSidebar
      v-else-if="
        username.match('birchteladmin') ||
        admin === 'birchteladmin' ||
        username === 'sbr' ||
        username === 'nt'
      "
    />

    <SCGSidebar v-else-if="username === 'SCGdemo' || username === 'TAdemo'" />
    <SmarthomeSidebar v-else-if="username === 'smarthome'" />
    <StockSidebar v-else-if="username === 'stockdemo'" />
    <SentenanceSidebar v-else-if="username === 'sentenancedemo'" />
    <HinoSidebar v-else-if="username === 'hinoIT' || admin === 'hinoIT'" />
    <SmartfarmSidebar v-else-if="username === 'farmdemo'" />
    <HotelSidebar v-else-if="username === 'hoteldemo'" />
    <FPSSidebar
      v-else-if="
        username === 'FPSadmin' ||
        username === 'FPSmanage' ||
        username === 'FPSoperator'
      "
    />
    <SpartanSidebar v-else-if="username === 'spartan'" />
    <SyntecSidebar v-else-if="username === 'syntecdemo'" />
    <TruedigitalSidebar v-else-if="username === 'truedigital'" />
    <TempdemoSidebar
      v-else-if="username === 'tempdemo01' || username === 'tempdemo02'"
    />
    <UnicornSidebar v-else-if="username === 'unicorndemo'" />
    <VsteelSidebar v-else-if="username === 'VSteeldemo'" />
    <WarehouseSidebar v-else-if="username === 'warehousedemo'" />
    <YamahaaqiSidebar v-else-if="username === 'yamahaaqidemo'" />
    <YamahaSidebar
      v-else-if="
        username === 'yamahademo' ||
        username === 'aisdemo' ||
        admin === 'yamahademo'
      "
    />
    <DnetSidebar
      v-else-if="
        username === 'dhanarak-admin' ||
        username === 'dhanarak-user' ||
        admin === 'dnet'
      "
    />
    <SwitfSidebar v-else-if="username === 'swiftdemo'" />
    <XtpleSidebar v-else-if="username === 'Xtpledemo'" />
    <NgkSidebar v-else-if="admin === 'poonsak.ngk'"/>
    <AssetWorldSidebar v-else-if="username === 'awcdemo'" />
    <DefaultSidebar v-else />
  </div>
</template>

<script>
import BetagroSidebar from "./SideBarCustomer/BetagroSidebar.vue";
import EncoSidebar from "./SideBarCustomer/EncoSidebar.vue";
import CamillianSicebar from "./SideBarCustomer/CamillianSicebar.vue";
import IapcSidebar from "./SideBarCustomer/IapcSidebar.vue";
import KPcoolSidebar from "./SideBarCustomer/KPcoolSidebar.vue";
import KubotaSidebar from "./SideBarCustomer/KubotaSidebar.vue";
import PttSidebar from "./SideBarCustomer/PttSidebar.vue";
import SyntecSidebar from "./SideBarCustomer/SyntecSidebar.vue";
import VsteelSidebar from "./SideBarCustomer/VsteelSidebar.vue";
import YamahaaqiSidebar from "./SideBarCustomer/YamahaaqiSidebar.vue";
import YamahaSidebar from "./SideBarCustomer/YamahaSidebar.vue";
import DefaultSidebar from "./SideBarCustomer/DefaultSidebar.vue";
import SwitfSidebar from "./SideBarCustomer/SwiftSidebar.vue";
import SpartanSidebar from "./SideBarCustomer/SpartanSidebar.vue";
import FrasersSidebar from "./SideBarCustomer/FrasersSidebar.vue";
import SmarthomeSidebar from "./SideBarCustomer/SmarthomeSidebar.vue";
import SbrSidebar from "./SideBarCustomer/SbrSidebar.vue";
import SmartfarmSidebar from "./SideBarCustomer/smartfarmde.vue";
import TruedigitalSidebar from "./SideBarCustomer/TruedigitalSidebar.vue";
import LindeSidebar from "./SideBarCustomer/LindeSidebar.vue";
import RivacoldSidebar from "./SideBarCustomer/RivacoldSidebar.vue";
import DnetSidebar from "./SideBarCustomer/D-netSidebar.vue";
import HinoSidebar from "./SideBarCustomer/HinoSidebar.vue";
import UnicornSidebar from "./SideBarCustomer/UnicornSidebar.vue";
import TempdemoSidebar from "./SideBarCustomer/TempdemoSidebar.vue";
import WarehouseSidebar from "./SideBarCustomer/WarehouseSidebar.vue";
import FPSSidebar from "./SideBarCustomer/FPSSidebar.vue";
import CPFSidebar from "./SideBarCustomer/CPFSidebar.vue";
import SCGSidebar from "./SideBarCustomer/SCGSidebar.vue";
import HotelSidebar from "./SideBarCustomer/HotelSidebar.vue";
import AjinomotoSidebar from "./SideBarCustomer/AjinomotoSidebar.vue";
import RFIDSidebar from "./SideBarCustomer/RFIDSidebar.vue";
import OfficemateSidebar from "./SideBarCustomer/OfficemateSidebar.vue";
import StockSidebar from "./SideBarCustomer/StockSidebar.vue";
import RamaSidebar from "./SideBarCustomer/RamaSidebar.vue";
import GPSSidebar from "./SideBarCustomer/GPSSidebar.vue";
import QCONSidebar from "./SideBarCustomer/QCONSidebar.vue";
import XtpleSidebar from "./SideBarCustomer/XtpleSidebar.vue";
import LTCSidebar from "./SideBarCustomer/LTCSidebar.vue";
import SentenanceSidebar from "./SideBarCustomer/SentenanceSidebar.vue";
import MhesiSidebar from "./SideBarCustomer/MhesiSidebar.vue";
import NgkSidebar from "./SideBarCustomer/ngkSidebar.vue";
import AssetWorldSidebar from "./SideBarCustomer/AssetWorldSidebar.vue";


export default {
  components: {
    BetagroSidebar,
    QCONSidebar,
    SyntecSidebar,
    IapcSidebar,
    RivacoldSidebar,
    KubotaSidebar,
    PttSidebar,
    YamahaaqiSidebar,
    VsteelSidebar,
    KPcoolSidebar,
    YamahaSidebar,
    CamillianSicebar,
    SentenanceSidebar,
    SmartfarmSidebar,NgkSidebar,
    EncoSidebar,
    DefaultSidebar,
    SpartanSidebar,
    FrasersSidebar,
    SmarthomeSidebar,
    SbrSidebar,
    TruedigitalSidebar,
    OfficemateSidebar,
    LindeSidebar,
    DnetSidebar,
    RivacoldSidebar,
    HinoSidebar,
    UnicornSidebar,
    TempdemoSidebar,
    SwitfSidebar,
    WarehouseSidebar,
    FPSSidebar,
    CPFSidebar,
    SCGSidebar,
    AjinomotoSidebar,
    HotelSidebar,
    RFIDSidebar,
    StockSidebar,
    RamaSidebar,
    GPSSidebar,
    XtpleSidebar,
    LTCSidebar,
    MhesiSidebar,
    AssetWorldSidebar,
  },
  name: "SideBar",
  props: {
    parent: {
      type: String,
    },
    sidebarLinks: {
      type: Array,
      required: true,
    },
    sidebarLinks_dashboard: {
      type: Array,
      required: true,
    },
    index: {
      default: null,
      type: [String, Number],
    },
  },
  data: () => ({
    doNotClose: false,
    admin: "",
    windowWidth: window.innerWidth,
    username: "",
    admin: "",
    openItems: true,
    intervalToken: null,
  }),
  computed: {
    sideindex() {
      // console.log(this.$session.get('package'))
      switch (this.$session.get("package")) {
        case 0:
          return [0, 0, 0, 6, 7, 8, 0, 0, 15, 15];
        case 1:
          return [0, 0, 0, 6, 7, 10, 10, 13, 13, 18];
        case 2:
          return [0, 0, 0, 2, 7, 8, 0, 0, 16, 19];
        case 3:
          return [0, 0, 0, 4, 7, 8, 0, 0, 17, 19];
        case 4:
          return [18, 23, 0, 6, 7, 10, 10, 13, 13, 18, 18, 21, 24, 26, 27];
        case 5:
          return [0, 0, 0, 6, 7, 10, 0, 0, 13, 17];
        case 6:
          return [0, 0, 0, 6, 7, 10, 0, 0, 13, 17, 18, 21, 24, 26, 27];
        case 7:
          return [0, 0, 0];
        case 8:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 9:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 10:
          return [18, 23, 0, 0, 6, 9, 9, 11, 11, 15, 18, 21, 24, 26, 27];
        case 11:
          return [0, 0, 0, 5, 7, 10, 0, 0, 13, 16];
        default:
          return [0, 0, 0, 3, 7, 8, 0, 0, 14, 16];
      }
      // if(this.$session.get('package')) {
      //   return [0,4,4,7,7,8,8,15]
      // }else{
      //   return [0,3,4,5,0,0,9,11]
      // }
    },
    //This is for mobile trigger
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", val);
      },
    },
  },
  watch: {},
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebar();
    },
    setSidebar() {
      if (this.windowWidth < 1170) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
        this.doNotClose = false;
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
      }
    },
    logout() {
      this.sideindex = [];
      this.$session.clear();
      this.$router.push({
        name: "Login",
      });
    },
    reToken() {
      this.intervalToken = setTimeout(async () => {
        await this.$jwt.getNewAccessToken();
        this.reToken();
      }, 1000 * 60 * 30);
      console.log("reToken");
    },
  },
  mounted() {
    // console.log('SPEAK')
    // // console.log(this.$session.get('package'))
    // if(!this.$session.get('package')) {
    //   this.sideindex = [0,4,4,7,7,9,9,15]
    // }else{
    //   this.sideindex = [0,2,4,6,0,0,9,11]
    // }
    this.admin = this.$session.get("admin");
    this.username = this.$session.get("username");
    console.log(this.username, this.admin);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebar();
    switch (this.username || this.admin) {
      case "betagrodemo":
        console.log("betagrodemo");
        // var element = document.getElementsByClassName('vs-sidebar--items');
        // element.classList.add("mystyle");
        var elemnavbar = document.getElementsByClassName("vs-sidebar");
        Array.prototype.filter.call(elemnavbar, function (testElement) {
          testElement.style.background = "#212121";
          // testElement.style.height = '100%';
        });
        // document.getElementById("stfont").style.color = "#ffffff";

        var fontColor1 = document.getElementsByClassName("hide-in-minisidebar");
        Array.prototype.filter.call(fontColor1, function (testElement2) {
          testElement2.style.color = "#ffffff";
        });
        var fontColor2 = document.getElementsByClassName("vs-sidebar-group");
        Array.prototype.filter.call(fontColor2, function (testElement3) {
          testElement3.style.color = "#ffffff";
        });

        var fontColor3 = document.getElementsByClassName("vs-sidebar--items");
        Array.prototype.filter.call(fontColor3, function (testElement4) {
          testElement4.style.color = "#ffffff";
        });
        var fontColor4 = document.getElementsByClassName("h4");
        Array.prototype.filter.call(fontColor4, function (testElement5) {
          testElement5.style.color = "#ffffff";
        });
        // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
        break;
      case "pttdemo":
        // console.log("pttdemo");

        break;
      default:
      // console.log("Try looking up for a hint.");
    }

    // this.intervalToken = setInterval(() => {
    this.reToken();
    // }, 1000 * 60 * 30);
  },
  beforeDestroy() {
    this.sideindex = [];
    this.$session.clear();
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebar();
    clearTimeout(this.intervalToken);
  },
};
</script>

<style>
.mystyle {
  background: red;
  height: 100%;
}
#stfont {
  /*font-size 14px */
  font-size: 0.875rem;
  font-family: Arial, Helvetica, sans-serif;
}

.vs-sidebar-group.vs-sidebar-group-open > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar-group > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar {
  /*font-size 12px */
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  text-indent: 7px;
}
.vs-sidebar-group.vs-sidebar-group-open > h4:hover {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #47c93c;
  /* background: #48C93B; */
  /* background: #28a745;;
   color: aliceblue; */
}
.vs-sidebar-group > h4:hover {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  /* color: aliceblue; */
  color: #48c93b;
  /* background: #48C93B;
  background: #28a745;; */
}
.vuesax-app-is-ltr .vs-sidebar-group h4 i {
  right: 10px;
  top: 5.5px;
}
.vs-sidebar-group.vs-sidebar-group-open > h4 {
  color: aliceblue;
  margin: 6px;
  border-radius: 20px;
  background: #48c93b !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.vs-sidebar-group.vs-sidebar-group-open > h4:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  color: aliceblue;
}
#btnbackover {
  margin: 0px 5px 0px 10px;
  border-radius: 30px;
  display: flex;
  width: 90%;
  background-color: #4caf50;
  align-items: center;
}
#parentx {
  background: #47c93c;
}
</style>
